import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/Agent/AgentModel';
import { RootState } from '../../../store';
import AgentForm from '../AgentForm/AgentForm';

const AgentModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxAgent = useSelector((state: RootState) => state.models.agent);

  return (
    <Modal
      title={!!reduxAgent.id ? 'Modifica' : 'Adauga'}
      open={reduxAgent.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <AgentForm />
    </Modal>
  );
};

export default AgentModal;
